import React, { Component, CSSProperties } from "react";

import "./StripeInactiveSubscription.scss";
import IStripeGetLatestInvoiceUrlDTO from "../../../models/DTO/IStripeGetLatestInvoiceUrlDTO";
import IStripeOnGetLatestInvoiceUrlDTO from "../../../models/DTO/IStripeOnGetLatestInvoiceUrlDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ISupplierModel from "../../../models/ISupplierModel";
import IUser from "../../../models/IUser";
import IUserUI from "../../../models/IUserUI";
import UserTypesEnum from "../../../models/UserTypesEnum";
import ActivityIndicator from "../../shared/ActivityIndicator/ActivityIndicator";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import { Socket } from "socket.io-client";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    logoutFn: () => void;
};

type State = {
    hostedInvoiceUrl?: string;
    hasError: boolean;
};

class StripeInactiveSubscription extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.StripeOnGetLatestInvoiceUrl, this.onGetLatestInvoiceUrl);
        this.props.socket.on(EndpointsEnum.Notify, this.notify);

        this.getLatestInvoiceUrl();
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.StripeOnGetLatestInvoiceUrl, this.onGetLatestInvoiceUrl);
        this.props.socket.removeListener(EndpointsEnum.Notify, this.notify);
    }

    notify = () => {
        this.setState({
            hasError: true,
        });
    };

    getLatestInvoiceUrl = () => {
        if (this.props.userModel.userType?.id !== UserTypesEnum.ADMIN) {
            return null;
        }

        const payload: IStripeGetLatestInvoiceUrlDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.StripeGetLatestInvoiceUrl, payload);
    };

    onGetLatestInvoiceUrl = (data: IStripeOnGetLatestInvoiceUrlDTO) => {
        this.setState({
            hostedInvoiceUrl: data.url,
        });
    };

    render() {
        const style: CSSProperties = {
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            position: "absolute",
            zIndex: 100,
            backgroundColor: "rgba(0, 0, 0, 0.85)",
        };

        return (
            <div className="StripeInactiveSubscription position-absolute" style={style}>
                <div className={"mb-3"}>
                    <OwTitle title={"subscription_inactive"} className={"mb-2 text-warning"} leftIconName={"fad fa-exclamation-triangle"} />
                </div>
                {!this.props.supplierModel.disable_account ? (
                    <div className={"w-35r mb-3"}>
                        <OwLabel title={"subscription_inactive_help_text"} />
                    </div>
                ) : null}
                {this.props.userModel.userType?.id === UserTypesEnum.ADMIN && this.props.userModel.isSupplierUser ? (
                    <div>
                        {this.state.hostedInvoiceUrl ? (
                            <a className={"pointer text-primary"} href={this.state.hostedInvoiceUrl} target={"_blank"} rel="noreferrer">
                                <OwTranslate id={"resolve"} defaultMessage={"resolve"} />
                            </a>
                        ) : !this.state.hasError ? (
                            <div>
                                <ActivityIndicator active={true} />
                                <OwLabel title={"retrieving_subscription"} className={"ms-2"} />
                            </div>
                        ) : null}
                        {this.state.hasError ? (
                            <div>
                                <OwLabel title={"error_retrieving_invoice_url_contact_support"} className={"text-danger"} />
                            </div>
                        ) : null}
                    </div>
                ) : (
                    <div>
                        <OwLabel title={"please_have_admin_login_to_resolve"} />
                    </div>
                )}
                <div className={"mt-2"}>
                    <div>
                        <OwButton title={"logout"} fn={this.props.logoutFn} />
                    </div>
                </div>
            </div>
        );
    }
}

export default StripeInactiveSubscription;
